import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import EditButton from 'components/v2/buttons/EditButton';
import CargomaticSelect from 'components/v2/select';
import CapabilityCircle from '../../user/CapabilityCircle';

class ShipmentDetailDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      valueObj: this.props.value,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!this.state.showEdit && newProps.value !== this.state.valueObj) {
      this.setState({ valueObj: newProps.value });
    }
  }

  handleSelect = (valueObj) => {
    this.setState({ valueObj });
  };

  handleSave = () => {
    this.setState({ showEdit: false }, this.props.onSave(this.state.valueObj));
  };

  renderInlineEditing() {
    const { t } = this.props;
    if (!this.state.showEdit) {
      return null;
    }

    return (
      <div className="" data-testid="pod-status-update-wrapper">
        <CargomaticSelect
          dataTestId="CargomaticSelect-11d8255a"
          className="mb-4 sm:col-span-1 w-48"
          items={this.props.items.filter(({ selectable }) => selectable)}
          disabled={this.props.disabled}
          value={this.state.valueObj?.value}
          onSelect={this.handleSelect}
          valueKey="value"
          textKey="localizationSlug"
        />
        <div
          data-testid="div-6aa143f4"
          className="flex items-center mt-2 space-x-2"
        >
          <button
            key={2}
            onClick={this.handleSave}
            className="button button-green carrier-shipmentDetailDateItem-editAppointment"
            data-testid="save-pod-status-update"
          >
            {titleize(t('SAVE'))}
          </button>
          <button
            key={1}
            type="button button-gray"
            onClick={() => {
              this.setState({ showEdit: false, valueObj: this.props.value });
            }}
            data-testid="cancel-pod-status-update"
          >
            {t('CANCEL')}
          </button>
        </div>
      </div>
    );
  }

  renderValue() {
    const { t } = this.props;
    if (this.state.showEdit) {
      return null;
    }

    return (
      <div data-testid="div-efa37378" className="flex items-center space-x-2">
        <span data-testid="span-066285cc" className="mb-0 mr-3 ">
          {t(this.state.valueObj.localizationSlug)}
        </span>
        {this.props.showIcon && (
          <CapabilityCircle checked={this.props.iconValue} />
        )}
        {this.props.editable && (
          <EditButton
            title={t('EDIT_DATE')}
            disabled={!this.props.editable}
            onClick={() => this.setState({ showEdit: true })}
            dataTestId="edit-pod-status"
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div data-testid="div-486af12d">
        {this.state.showEdit ? this.renderInlineEditing() : this.renderValue()}
      </div>
    );
  }
}

ShipmentDetailDropdown.propTypes = {
  items: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  showIcon: PropTypes.bool,
  iconValue: PropTypes.bool,
};

ShipmentDetailDropdown.defaultProps = {
  disabled: false,
  showIcon: false,
  iconValue: false,
  editable: false,
};

export default withTranslation()(ShipmentDetailDropdown);
